<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Service Accounts</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/locked/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        Locked service accounts
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/deleted/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        Deleted service accounts
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/users/create-service-account/${tid}`" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        Create service account
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <p class="text-muted">Service accounts are used for API access and automation. They cannot sign in through the UI.</p>
            <UsersTable v-if="serviceAccounts.length" :users="serviceAccounts" :showActive="false"></UsersTable>
            <h4 v-else>No service accounts found</h4>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import UsersTable from '@Organizations/Users/Components/UsersTable.vue'
    import { useSearchAllUsersQueryV1 } from '@Organizations/Users/queries-vue-composables'

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))
    
    const {
        runSearchAllUsersQueryV1,
        modelSearchAllUsersQueryV1: allUsersSearchResult
    } = useSearchAllUsersQueryV1(tid, '', true, false, false, true)
    // includeServiceAccounts = true → ONLY service accounts returned


    const users = computed(() => allUsersSearchResult.value?.Users ?? [])
    const serviceAccounts = users // already filtered by query

    onMounted(() =>
    {
        document.title = 'Service Accounts'
        runSearchAllUsersQueryV1()
    })
</script>
